<template>
  <PopDialog2
    title="방 정보 수정"
    :visible="props.visible"
    :okCallback="onOkClick"
    :cancelCallback="onCancelClick"
  >
    <div class="md-layout">
      <div class="md-layout-item md-size-50 mx-auto text-center mb-4">
        <!-- <h2 class="title mt-4">{{props.roomName}} 보일러</h2> -->
        <h2 :class="`title mt-4 ml-${isOwnerZone && curtainDevices.length == 1 ? 4 : 0}`">
          {{ curtainDevices.length > 1 ? '커튼' : curtainDevices[0].name }}
          <button class="btn dropdown-toggle" type="button" id="menus" data-bs-toggle="dropdown" aria-expanded="true" ref="menusButton" v-if="isOwnerZone && curtainDevices.length == 1" />
          <ul class="dropdown-menu" aria-labelledby="menus" v-if="isOwnerZone && curtainDevices.length == 1">
            <li class="dropdown-item" @click="onChangeNameClick">이름 변경</li>
            <li class="dropdown-item" @click="onDeleteClick">삭제</li>
          </ul>
        </h2>
        <!-- <button
          type="button"
          class="btn btn-light mb-4"
          :style="`width: 6rem; height: 6rem; border-radius: 3rem; background-color: ${getPower ? '#ffe082' : 'inherits'};`"
          @click="props.handlePowerClick"
        >
          <span style="font-size: 1.0rem">
            {{ getPower ? "열기" : "닫기" }}
          </span>
        </button> -->

        <div class="btn-group mb-4" role="group">
          <button type="button" class="btn btn-light" style="border-radius: 2rem 0rem 0rem 2rem; width: 5rem; height: 6rem; background-color: #ffe082" @click="props.handlePowerClick(MQTTCurtainCommand.IsOpen)">열기</button>
          <button type="button" class="btn btn-light" style=" width: 5rem;height: 6rem; background-color: #fff8e1" @click="props.handlePowerClick(MQTTCurtainCommand.IsStop)">멈춤</button>
          <button type="button" class="btn btn-light" style="border-radius: 0rem 2rem 2rem 0rem; width: 5rem; height: 6rem; background-color: #ffe082" @click="props.handlePowerClick(MQTTCurtainCommand.IsClose)">닫기</button>
        </div>

        <div class="curtain-modal-controls">
          <div class="curtain-modal-sliders px-2">
          <ListGroupItem class="curtain-modal-slider-row">
            <Slider
              name="닫힘 정도"
              id="percent"
              layout="stacked"
              thin
              filled-track
              track-variant="neutral"
              :default="currentPercent"
              :min="0"
              :max="100"
              :step="1"
              value-suffix="%"
              :display-value-override="displayPercentValue === '미설정' ? '미설정' : null"
              v-on:onSliderChanged="onPercentChanged"
            />
          </ListGroupItem>
          </div>
          <ListGroupItem
            class="curtain-modal-direction-row px-2"
            v-if="isSingleCurtain"
          >
            <div class="container" style="padding-left: 0px; padding-right: 0px;">
              <div class="row align-items-center">
                <div :class="`col-3`">
                  <label :for="props.id" class="form-label mb-0 fw-normal">
                    {{ isSingleRono ? '블라인드' : '커튼' }} 방향
                  </label>
                </div>

                <div class="col d-flex align-items-center" style="margin-left: 20px; text-align: left;">
                  <input
                    class="form-check-input"
                    id="reverseCheck"
                    type="checkbox"
                    :checked="displayReverse"
                    @change="onReverseChange"
                  />
                  <label class="form-check-label ms-2" for="reverseCheck">
                    {{ displayReverse ? `${isSingleRono ? '블라인드가' : '커튼이'} 역방향으로 움직입니다.` : `${isSingleRono ? '블라인드가' : '커튼이'} 정방향으로 움직입니다.` }}
                  </label>
                </div>
              </div>
            </div>
          </ListGroupItem>

          <ListGroupItem 
            v-if="isSingleRono"
            style="padding-top: 0.3rem; padding-bottom: 0.3rem;"
          >
            <div class="container" style="padding-left: 0px; padding-right: 0px;">
              <div class="row" style="text-align: center;">
                <div
                  :class="`col-3`"
                  :style="`margin-top: 8px`"
                >
                  <label :for="props.id" class="form-label fw-normal">
                    슬랫 개방
                  </label>
                </div>
                <div class="col" style="width: 100%; margin-top: 4px; text-align: left;">
                  <div class="btn-group w-100" role="group">
                    <button type="button" class="btn btn-outline-primary flex-fill d-flex justify-content-center align-items-center" @click="onSlatOpenClick">
                      <i class="fa-solid fa-minus me-2" style="margin-top: 2px;"></i>열기
                    </button>
                    <button type="button" class="btn btn-outline-primary flex-fill d-flex justify-content-center align-items-center" @click="onSlatCloseClick">
                      <i class="fa-solid fa-minus fa-rotate-90 me-2" style="margin-top: 2px;"></i>닫기
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ListGroupItem>

          <template v-if="isSinglePhysicalCurtain">
            <ListGroupItem
              v-if="showCurtainLinkedLightsUi"
              style="padding-top: 0.3rem; padding-bottom: 0.3rem;"
            >
              <button
                type="button"
                class="btn btn-primary w-100"
                @click="onLinkedLightsClick"
              >
                조명 연동
              </button>
            </ListGroupItem>
            <ListGroupItem style="padding-top: 0.3rem; padding-bottom: 0.3rem;">
              <div class="d-flex gap-2 w-100">
                <button
                  type="button"
                  class="btn btn-outline-primary flex-fill"
                  :disabled="isBoundButtonAssigned"
                  @click="onBoundButtonAssignClick"
                >
                  물리 버튼 할당
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary flex-fill"
                  :disabled="!isBoundButtonAssigned"
                  @click="onBoundButtonClearClick"
                >
                  물리 버튼 해제
                </button>
              </div>
            </ListGroupItem>
            <ListGroupItem
              v-if="isBoundButtonAssigned"
              style="padding-top: 0.2rem; padding-bottom: 0.2rem;"
            >
              <div
                class="virtual-switch-info-root w-100"
                :class="{ 'is-expanded': isBoundButtonInfoExpanded }"
              >
                <div
                  class="virtual-switch-info-header"
                  role="button"
                  tabindex="0"
                  @click="toggleBoundButtonInfo"
                  @keyup.enter="toggleBoundButtonInfo"
                  @keyup.space.prevent="toggleBoundButtonInfo"
                >
                  <div class="virtual-switch-info-title">
                    <span>할당된 물리 버튼</span>
                  </div>
                  <div class="virtual-switch-info-chevron" aria-hidden="true">
                    <i :class="`fa ${isBoundButtonInfoExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`" style="font-size: 0.75rem;"></i>
                  </div>
                </div>
                <transition name="virtual-switch-expand">
                  <div v-show="isBoundButtonInfoExpanded" class="virtual-switch-info-body">
                    <div class="virtual-switch-detail-row">
                      <span class="virtual-switch-detail-label">
                        <i class="fa-solid fa-hashtag" aria-hidden="true"></i>
                        시리얼
                      </span>
                      <span class="virtual-switch-detail-value">{{ boundButtonSerialWithName }}</span>
                    </div>
                    <div class="virtual-switch-detail-row">
                      <span class="virtual-switch-detail-label">
                        <i class="fa-solid fa-plug" aria-hidden="true"></i>
                        버튼 포트
                      </span>
                      <span class="virtual-switch-detail-value">{{ toDisplayLampPort(singleDevice.boundButton.port, singleDevice.boundButton.controllerId) }}</span>
                    </div>
                    <div class="virtual-switch-detail-row" v-if="boundButtonDisplayName">
                      <span class="virtual-switch-detail-label">
                        <i class="fa-solid fa-tag" aria-hidden="true"></i>
                        버튼 이름
                      </span>
                      <span class="virtual-switch-detail-value">{{ boundButtonDisplayName }}</span>
                    </div>
                    <div class="virtual-switch-detail-row">
                      <span class="virtual-switch-detail-label">자주 열림</span>
                      <select
                        class="form-select form-select-sm favorite-percent-select"
                        :value="favoriteOpenPercent"
                        @change="onFavoriteOpenChanged"
                      >
                        <option
                          v-for="p in favoritePercentOptions"
                          :key="`open-${p}`"
                          :value="p"
                        >{{ p }}%</option>
                      </select>
                    </div>
                    <div class="virtual-switch-detail-row">
                      <span class="virtual-switch-detail-label">자주 닫힘</span>
                      <select
                        class="form-select form-select-sm favorite-percent-select"
                        :value="favoriteClosePercent"
                        @change="onFavoriteCloseChanged"
                      >
                        <option
                          v-for="p in favoritePercentOptions"
                          :key="`close-${p}`"
                          :value="p"
                        >{{ p }}%</option>
                      </select>
                    </div>
                  </div>
                </transition>
              </div>
            </ListGroupItem>
          </template>

          <ListGroupItem style="padding-top: 0.3rem; padding-bottom: 0.3rem;" v-if="curtainDevices.length == 1 && isOwnerZone">
            <div class="container" style="padding-left: 0px; padding-right: 0px;">
              <div class="row">
                <div :class="`col-3`" :style="`margin-top: 8px`">
                </div>
                <div class="col">
                  <div class="flex-fill">
                    <div
                      class="fw-400 text-muted text-end me-1 mt-1"
                      style="font-size: 0.8rem"
                      @click="onSettingMortorAddressClick"
                    >
                      모터 주소 설정&nbsp;<i class="fa fa-chevron-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ListGroupItem>
        </div>

        <!-- <div style="margin-left: 20px;margin-right: 20px; margin-top: 10px;" v-if="isOwnerZone">
          <ListGroupItem 
            style="padding-top: 0.3rem; padding-bottom: 0.3rem;"
          >
            <button
              type="button"
              class="btn btn-primary flex-fill"
              @click="onAddVirtualDeviceClick"
            >
              가상버튼 추가
            </button>
          </ListGroupItem>
        </div> -->
      </div>
    </div>
  </PopDialog2>
        
  <CurtainMortorAddressModal
    v-if="curtainMortorAddressModal.visible && curtainDevices.length == 1"
    :visible="curtainMortorAddressModal.visible"
    :cancelCallback="curtainMortorAddressModal.hide"
    :roomName="props.roomName"
    :roomId="props.roomId"
    :deviceId="curtainDevices[0]._id"
  />
  <DeviceItemModal
    v-if="deviceItemModal.visible"
    :visible="deviceItemModal.visible"
    :okCallback="onUpdateDeviceName"
    :cancelCallback="deviceItemModal.hide"
    :deviceName="curtainDevices.length > 0 ? curtainDevices[0].name : ''"
    :groupId="props.roomId"
    :isInput="true"
  />
</template>

<script setup>
import { ref, defineProps, computed, getCurrentInstance, reactive, watch, nextTick, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { ButtonConfig, DeviceType, PowerState, MQTTTempCommand, MQTTCurtainCommand, MQTTDooyaRonoAction, MQTTDooyaRonoCommand, resolveCurtainItemPercent, isCurtainClosePercentSet } from '@/common/constants';
import useMqttControl from '@/common/hooks/useMqttControl';
import useModal from '@/common/hooks/useModal';
import PopDialog2 from '@/common/components/popup/PopDialog2.vue';
import Slider from '@/common/components/widgets/Slider.vue';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';
import CurtainMortorAddressModal from './CurtainMortorAddressModal.vue';
import DeviceItemModal from './DeviceItemModal.vue';
import Axios, { DeviceApi } from '@/api';
import { resolveBoundButtonDisplayName } from '@/common/utils/boundButtonLabel';
import { formatControllerSerialWithName, toDisplayLampPort } from '@/common/utils/controllerDisplayName';
import { buildButtonMapsForController, publishButtonMapsPayload } from '@/common/utils/buttonMaps';
import { SHOW_CURTAIN_LINKED_LIGHTS_UI } from '@/common/utils/curtainLinkedLights';

const BOUND_BUTTON_ASSIGN_TIMEOUT_MS = 30000;
const showCurtainLinkedLightsUi = SHOW_CURTAIN_LINKED_LIGHTS_UI;
const favoritePercentOptions = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

const mqttControl = reactive(useMqttControl());
const router = useRouter();
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const curtainMortorAddressModal = reactive(useModal());
const store = useStore();
const props = defineProps([
  'visible',
  'okCallback',
  'cancelCallback',
  'roomName',
  'roomId',
  'handlePowerClick',
]);
const deviceItemModal = reactive(useModal());
const menusButton = ref(null);
const reverseTimerId = ref(null);
const pendingReverse = ref(null);
const isBoundButtonInfoExpanded = ref(false);
const isBoundButtonAssignWaiting = ref(false);
const boundButtonAssignTimerId = ref(null);
const boundButtonAssignCountdownId = ref(null);
const boundButtonAssignRemainSec = ref(0);

const clampFavorite = (n, fallback) => {
  const v = Number(n);
  if (!Number.isFinite(v)) return fallback;
  return Math.max(0, Math.min(100, Math.round(v / 10) * 10));
};

const toggleBoundButtonInfo = () => {
  isBoundButtonInfoExpanded.value = !isBoundButtonInfoExpanded.value;
};
const zone = computed(() => {
  if (store.state.home.zones.length > 0) {
    return store.getters['home/getCurrentZone'];
  } else return null;
});
const isOwnerZone = computed(() => {
  return zone.value?.ownerId != undefined
    && store.getters['account']?._id != undefined
    && zone.value?.ownerId === store.getters['account']?._id;
});
const group = computed(() => {
  return zone.value.groups.find((g) => g._id === props.roomId);
});
const devices = computed(() => {
  return group.value ? group.value.devices : undefined;
});
const curtainDevices = computed(() => {
  return devices.value.filter(
    (d) => d.type === 3 || d.type === 5 || d.type === 6,
  );
});

const isSingleCurtain = computed(() => {
  const list = curtainDevices.value;
  return list.length === 1;
});
const singleDevice = computed(() =>
  isSingleCurtain.value ? curtainDevices.value[0] : null,
);
const isSinglePhysicalCurtain = computed(() =>
  !!(singleDevice.value && !singleDevice.value.isVirtual),
);
const isSingleDooya = computed(() => {
  const list = curtainDevices.value;
  return list.length === 1 && list[0]?.type === DeviceType.Dooya;
});
const singleDooyaDevice = computed(() => {
  if (isSingleDooya.value) {
    return curtainDevices.value.find(d => d.type === DeviceType.Dooya);
  }
  return null;
});
const isSingleRono = computed(() => {
  const list = curtainDevices.value;
  return list.length === 1 && list[0]?.type === DeviceType.Rono;
});
const singleRonoDevice = computed(() => {
  if (isSingleRono.value) {
    return curtainDevices.value.find(d => d.type === DeviceType.Rono);
  }
  return null;
});

const boundButtonSettingCount = computed(() => {
  return store.getters['home/getBoundButtonSettingCount'];
});
const isBoundButtonAssigned = computed(() => {
  const bb = singleDevice.value?.boundButton;
  return bb?.controllerId != null && bb?.port != null;
});
const boundButtonDisplayName = computed(() =>
  resolveBoundButtonDisplayName(singleDevice.value, store.getters['home/getZones']),
);
const boundButtonSerialWithName = computed(() => {
  const serial = singleDevice.value?.boundButton?.controllerId;
  if (serial == null) return '';
  const sid = String(serial);
  const zones = store.getters['home/getZones'] || [];
  for (const z of zones) {
    const found = (z.controllers || []).find((c) => String(c?._id) === sid);
    if (found) return formatControllerSerialWithName(found);
  }
  return sid;
});
const favoriteOpenPercent = computed(() =>
  clampFavorite(singleDevice.value?.item?.favoriteOpenPercent, 30),
);
const favoriteClosePercent = computed(() =>
  clampFavorite(singleDevice.value?.item?.favoriteClosePercent, 70),
);

const boundButtonAssignWaitDescription = (sec) =>
  `설정 모드로 진입한 뒤 할당할 물리 버튼을 길게 눌러주세요.\n남은 시간 ${sec}초`;

const clearBoundButtonAssignTimers = () => {
  if (boundButtonAssignTimerId.value) {
    clearTimeout(boundButtonAssignTimerId.value);
    boundButtonAssignTimerId.value = null;
  }
  if (boundButtonAssignCountdownId.value) {
    clearInterval(boundButtonAssignCountdownId.value);
    boundButtonAssignCountdownId.value = null;
  }
};

const stopBoundButtonAssignWait = ({ clearSettingDevice = true } = {}) => {
  clearBoundButtonAssignTimers();
  isBoundButtonAssignWaiting.value = false;
  if (clearSettingDevice) {
    store.commit('home/setBoundButtonSettingDevice', undefined);
  }
  emitter.emit('hideLoading');
};

const exitBoundButtonAssignPreview = async (serial, port) => {
  if (!serial) return;
  try {
    await store.dispatch('home/fetchAllZones');
    let maps = await buildButtonMapsForController(
      serial,
      store.getters['home/getZones'],
    );
    if (!maps.length && Number.isInteger(Number(port))) {
      const p = Number(port);
      maps = [{ port: p, ports: [p] }];
    }
    publishButtonMapsPayload(mqttControl, serial, maps);
  } catch (e) {
    console.error('exit setting preview after curtain boundButton assign failed:', e);
  }
};

watch(boundButtonSettingCount, async () => {
  if (!isBoundButtonAssignWaiting.value) return;

  stopBoundButtonAssignWait({ clearSettingDevice: false });
  emitter.emit('hidePopAlert');
  await nextTick();

  const err = store.state.home.boundButtonLastError;
  if (err) {
    store.commit('home/setBoundButtonLastError', undefined);
    const errObj = typeof err === 'object' && err != null
      ? err
      : { message: String(err), hint: '', serial: undefined };
    const parts = [];
    if (errObj.message) parts.push({ text: errObj.message });
    if (errObj.hint) parts.push({ text: errObj.hint, danger: true });
    const onDismiss = async () => {
      await exitBoundButtonAssignPreview(errObj.serial, errObj.port);
    };
    emitter.emit('showPopAlert', {
      descriptionParts: parts.length > 0 ? parts : undefined,
      description: parts.length === 0 ? String(err) : undefined,
      okCallback: onDismiss,
      closeCallback: onDismiss,
    });
    return;
  }

  store.commit('home/setBoundButtonLastAbsorb', undefined);
  const bb = singleDevice.value?.boundButton;
  const serial = bb?.controllerId;
  const port = bb?.port;
  try {
    await store.dispatch('home/fetchAllZones');
    if (serial) {
      const maps = await buildButtonMapsForController(
        serial,
        store.getters['home/getZones'],
      );
      publishButtonMapsPayload(mqttControl, serial, maps);
    }
  } catch (e) {
    console.error('button maps push after curtain boundButton failed:', e);
  }

  isBoundButtonInfoExpanded.value = true;
  const portLabel = port != null ? toDisplayLampPort(port, serial) : null;
  const boundName = boundButtonDisplayName.value;
  emitter.emit('showPopAlert', {
    description: boundName
      ? `물리버튼 ${boundName}에 할당되었습니다`
      : portLabel != null
        ? `물리버튼 ${portLabel}번에 할당되었습니다`
        : '물리버튼에 할당되었습니다',
  });
});

const currentPercent = computed(() => {
  const list = curtainDevices.value;
  if (list.length === 0) {
    return 50;
  }
  return Math.max(...list.map((d) => resolveCurtainItemPercent(d.item, 50)));
});
const showCurrentPercent = computed(() =>
  curtainDevices.value.some((d) => d.type === DeviceType.Dooya || d.type === DeviceType.Rono),
);
const displayPercentValue = computed(() => {
  const list = curtainDevices.value;
  if (list.length === 0) {
    return '미설정';
  }
  const thermostatCurtains = list.filter((d) => d.type === DeviceType.Curtain);
  if (thermostatCurtains.length > 0) {
    return Math.max(...thermostatCurtains.map((d) => resolveCurtainItemPercent(d.item, 50)));
  }
  const dooyaRonoDevices = list.filter(
    (d) => d.type === DeviceType.Dooya || d.type === DeviceType.Rono,
  );
  if (dooyaRonoDevices.length === 0) {
    return '미설정';
  }
  if (dooyaRonoDevices.some((d) => !isCurtainClosePercentSet(d.item))) {
    return '미설정';
  }
  return Math.max(...dooyaRonoDevices.map((d) => resolveCurtainItemPercent(d.item, 50)));
});
const currentReverse = computed(() => {
  const list = curtainDevices.value;
  if (list.length === 0) return false;
  if (list.length === 1) return list[0].item.reverse == 1;
  return list.some((d) => d.item.reverse == 1);
});
const displayReverse = computed(() =>
  pendingReverse.value !== null ? pendingReverse.value : currentReverse.value,
);
const currentAddress = computed(() => curtainDevices.value.length > 0 ? curtainDevices.value[0].item.address : 1);
const dooyaDirectionStatus = computed(() => store.state.home?.dooya?.directionStatus);
const ronoDirectionStatus = computed(() => store.state.home?.rono?.directionStatus);

const getPower = computed(() => {
  return curtainDevices.value.some((d) => d.item?.close == PowerState.On);
});

watch(() => props.visible, (v) => {
  if (v) {
    if (isBoundButtonAssigned.value) {
      isBoundButtonInfoExpanded.value = true;
    }
    return;
  }
  pendingReverse.value = null;
  isBoundButtonInfoExpanded.value = false;
  // 물리버튼 할당 대기 중에는 설정 팝업을 닫아도 대기를 유지한다
});

onBeforeUnmount(() => {
  if (isBoundButtonAssignWaiting.value || boundButtonAssignTimerId.value) {
    stopBoundButtonAssignWait();
    emitter.emit('hidePopAlert');
  }
});

watch(dooyaDirectionStatus, async (next, prev) => {
  if (prev == 1 && next == 2) {
    console.log('dooya directionStatus: 1 -> 2');
    if (reverseTimerId.value && pendingReverse.value !== null) {
      clearTimeout(reverseTimerId.value);
      reverseTimerId.value = null;
      emitter.emit('hideLoading');
      await requestUpdateDevice(singleDooyaDevice.value._id, {
        item: { reverse: pendingReverse.value ? 1 : 0 }
      });
      pendingReverse.value = null;
    }
  }
});
watch(ronoDirectionStatus, async (next, prev) => {
  if (prev === 1 && next === 2) {
    console.log('rono directionStatus: 1 -> 2');
    if (reverseTimerId.value && pendingReverse.value !== null) {
      clearTimeout(reverseTimerId.value);
      reverseTimerId.value = null;
      emitter.emit('hideLoading');
      await requestUpdateDevice(singleRonoDevice.value._id, {
        item: { reverse: pendingReverse.value ? 1 : 0 }
      });
      pendingReverse.value = null;
    }
  }
});

const deviceState = (type) => {
  return devices.value
    .filter((d) => d.type == type)
    .some((d) => d.item.close == PowerState.On);
};

const onCancelClick = () => {
  if (props.cancelCallback) {
    props.cancelCallback();
  }
};

const onOkClick = () => {
  onCancelClick();
};

const onFavoriteOpenChanged = async (e) => {
  if (!singleDevice.value) return;
  const percent = clampFavorite(e?.target?.value ?? e, 30);
  try {
    await requestUpdateDevice(singleDevice.value._id, {
      item: { favoriteOpenPercent: percent },
    });
  } catch (err) {
    console.log(err);
  }
};

const onFavoriteCloseChanged = async (e) => {
  if (!singleDevice.value) return;
  const percent = clampFavorite(e?.target?.value ?? e, 70);
  try {
    await requestUpdateDevice(singleDevice.value._id, {
      item: { favoriteClosePercent: percent },
    });
  } catch (err) {
    console.log(err);
  }
};

const startBoundButtonAssignWait = () => {
  if (!singleDevice.value) return;
  if (isBoundButtonAssigned.value) {
    emitter.emit('showPopAlert', {
      description: '이미 물리 버튼이 할당되어 있습니다.\n먼저 해제한 뒤 새로 할당해주세요.',
    });
    return;
  }
  store.commit('home/setBoundButtonLastError', undefined);
  store.commit('home/setBoundButtonLastAbsorb', undefined);
  store.commit('home/setBoundButtonSettingDevice', singleDevice.value);
  isBoundButtonAssignWaiting.value = true;

  clearBoundButtonAssignTimers();

  const totalSec = Math.ceil(BOUND_BUTTON_ASSIGN_TIMEOUT_MS / 1000);
  boundButtonAssignRemainSec.value = totalSec;

  boundButtonAssignTimerId.value = setTimeout(async () => {
    boundButtonAssignTimerId.value = null;
    if (!isBoundButtonAssignWaiting.value) return;
    clearBoundButtonAssignTimers();
    isBoundButtonAssignWaiting.value = false;
    store.commit('home/setBoundButtonSettingDevice', undefined);
    emitter.emit('hidePopAlert');
    await nextTick();
    emitter.emit('showPopAlert', {
      description: '물리 버튼 할당 대기 시간이 초과되었습니다.',
    });
  }, BOUND_BUTTON_ASSIGN_TIMEOUT_MS);

  boundButtonAssignCountdownId.value = setInterval(() => {
    if (!isBoundButtonAssignWaiting.value) return;
    const next = Math.max(0, boundButtonAssignRemainSec.value - 1);
    boundButtonAssignRemainSec.value = next;
    if (store.getters.visible) {
      store.commit('setDescription', boundButtonAssignWaitDescription(next));
    }
    if (next <= 0 && boundButtonAssignCountdownId.value) {
      clearInterval(boundButtonAssignCountdownId.value);
      boundButtonAssignCountdownId.value = null;
    }
  }, 1000);

  emitter.emit('showPopAlert', {
    title: '물리 버튼 할당',
    description: boundButtonAssignWaitDescription(totalSec),
    showCancel: true,
    showOk: false,
    cancelText: '취소',
    cancelCallback: () => {
      stopBoundButtonAssignWait();
    },
    closeCallback: () => {
      stopBoundButtonAssignWait();
    },
  });

  onCancelClick();
};

const onLinkedLightsClick = () => {
  if (!singleDevice.value?._id) return;
  onCancelClick();
  router.push(
    `/settings/curtain/groups/${props.roomId}/devices/${singleDevice.value._id}/linked-lights`,
  );
};

const onBoundButtonAssignClick = () => {
  if (isBoundButtonAssigned.value) {
    emitter.emit('showPopAlert', {
      description: '이미 물리 버튼이 할당되어 있습니다.\n먼저 해제한 뒤 새로 할당해주세요.',
    });
    return;
  }
  emitter.emit('showPopConfirm', {
    title: '물리 버튼 할당',
    description:
      '설정 모드에서 물리 버튼을 길게 누르면 이 커튼에 할당됩니다.\n기존 조명은 그대로 두고, 해당 포트만 커튼 제어로 전환됩니다.\n이미 다른 장치에 할당된 포트는 사용할 수 없습니다.\n계속하시겠습니까?',
    okText: '계속',
    cancelText: '취소',
    okCallback: () => {
      startBoundButtonAssignWait();
    },
  });
};

const onBoundButtonClearClick = () => {
  if (!singleDevice.value) return;
  emitter.emit('showPopConfirm', {
    title: '물리 버튼 해제',
    description:
      '할당된 물리 버튼을 해제하시겠습니까?\n해당 포트는 원래 조명 제어로 복원됩니다.',
    okText: '해제',
    cancelText: '취소',
    okCallback: async () => {
      try {
        const prevSerial = singleDevice.value?.boundButton?.controllerId;
        const result = await Axios.patch(`/devices/${singleDevice.value._id}/boundButton`, {
          boundButton: null,
        });
        if (result.resultCode === '0000') {
          store.commit('home/updateDeviceBoundButton', {
            deviceId: singleDevice.value._id,
            boundButton: undefined,
          });
          isBoundButtonInfoExpanded.value = false;
          try {
            await store.dispatch('home/fetchAllZones');
          } catch (e) {
            console.error('fetchAllZones after clear curtain boundButton failed:', e);
          }
          const restore = result.resultData?.restore;
          const serial = restore?.controllerId || prevSerial;
          if (serial) {
            try {
              const maps = await buildButtonMapsForController(
                serial,
                store.getters['home/getZones'],
              );
              publishButtonMapsPayload(mqttControl, serial, maps);
            } catch (e) {
              console.error('button maps push after clear curtain boundButton failed:', e);
            }
          }
          emitter.emit('showPopAlert', {
            description: '물리 버튼 할당이 해제되었습니다.\n해당 포트는 원래 조명으로 복원됩니다.',
          });
        } else {
          emitter.emit('showPopAlert', {
            description: result.resultMessage || '해제에 실패했습니다.',
          });
        }
      } catch (e) {
        emitter.emit('showPopAlert', {
          description: '물리 버튼 해제에 실패했습니다.',
        });
      }
    },
  });
};

const requestUpdateDevice = async (id, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.patch(DeviceApi.UPDATE_DEVICE.replace(':id', id), params);
      if (result.resultCode === '0000') {
        store.commit('home/updateDevice', {
          groupId: group.value._id,
          id,
          data: params,
        });
        resolve(result);
      } else {
        emitter.emit('showPopAlert', {
          description: result.resultMessage,
        });
        reject(result.resultMessage);
      }
    } catch (error) {
      emitter.emit('showPopAlert', {
        description: '장치 정보 수정에 실패했습니다.',
      });
      reject('장치 정보 수정에 실패했습니다.');
    }
  });
};

const requestDeleteDevice = async (deviceId) => {
  try {
    const result = await Axios.delete(
      DeviceApi.DELETE_DEVICE.replace(':id', deviceId),
    );
    if (result.resultCode === '0000') {
      onCancelClick();
      store.commit('home/deleteDevice', {
        zoneId: parseInt(zone.value._id),
        groupId: parseInt(props.roomId),
        deviceId,
      });
      return;
    }

    emitter.emit('showPopAlert', {
      description: result.resultMessage,
    });
  } catch (error) {
    console.log(error)
    emitter.emit('showPopAlert', {
      description: '장치 삭제 중 오류가 발생하였습니다.',
    });
  }
};

const onPercentChanged = (e) => {
  emitter.emit('showLoading');
  (async () => {
    try {
      await Promise.all(curtainDevices.value.map(async (device) => {
        if (device.type == 3) {
          mqttControl.onPublishTemp(device.controllerId, MQTTCurtainCommand.IsSetClosePercent, `${device.item.address},${e}`);
        } else if (device.type == 5) {
          mqttControl.onPublish(device.controllerId, device._id, {
            cmd: MQTTDooyaRonoCommand.DooyaCtrl,
            type: 1,
            data: {
              addr: parseInt(device.item.address, 10),
              action: MQTTDooyaRonoAction.Percent,
              percent: parseInt(e, 10),
            }
          });
        } else if (device.type == 6) {
          mqttControl.onPublish(device.controllerId, device._id, {
            cmd: MQTTDooyaRonoCommand.RonoCtrl,
            type: 1,
            data: {
              addr: parseInt(device.item.address, 10),
              action: MQTTDooyaRonoAction.Percent,
              percent: parseInt(e, 10),
            }
          });
        }
        await requestUpdateDevice(device._id, {
          item: { percent: e }
        });
      }));
      setTimeout(() => emitter.emit('hideLoading'), curtainDevices.value.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
    } catch (err) {
      emitter.emit('hideLoading');
    }
  })();
};

const onReverseChange = (e) => {
  const newReverse = e.target.checked;
  pendingReverse.value = newReverse;
  emitter.emit('showLoading');
  (async () => {
    try {
      await Promise.all(curtainDevices.value.map(async (device) => {
        if (device.type == 3) {
          mqttControl.onPublishTemp(device.controllerId, MQTTCurtainCommand.IsWriteDirection, `${device.item.address},${newReverse ? '1' : '0'}`);
          setTimeout(async () => {
            await requestUpdateDevice(device._id, {
              item: { reverse: newReverse ? 1 : 0 }
            });
            pendingReverse.value = null;
            emitter.emit('hideLoading');
          }, curtainDevices.value.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
        } else if (device.type == 5 && isSingleDooya.value) {
          store.commit('home/setDooyaDirectionStatus', 1);
          mqttControl.onPublish(device.controllerId, device._id, {
            cmd: MQTTDooyaRonoCommand.DooyaCtrl,
            type: 1,
            data: {
              addr: parseInt(device.item.address, 10),
              action: MQTTDooyaRonoAction.Direction,
              value: newReverse ? 1 : 0,
            }
          });
          reverseTimerId.value = setTimeout(() => {
            reverseTimerId.value = null;
            pendingReverse.value = null;
            store.commit('home/clearDooya', 0);
            emitter.emit('hideLoading');
            emitter.emit('showPopAlert', {
              description: '방향 설정에 실패했습니다.',
            });
          }, 5000);
        } else if (device.type == 6 && isSingleRono.value) {
          store.commit('home/setRonoDirectionStatus', 1);
          mqttControl.onPublish(device.controllerId, device._id, {
            cmd: MQTTDooyaRonoCommand.RonoCtrl,
            type: 1,
            data: {
              addr: parseInt(device.item.address, 10),
              action: MQTTDooyaRonoAction.Direction,
              value: newReverse ? 1 : 0,
            }
          });
          reverseTimerId.value = setTimeout(() => {
            reverseTimerId.value = null;
            pendingReverse.value = null;
            store.commit('home/clearRono', 0);
            emitter.emit('hideLoading');
            emitter.emit('showPopAlert', {
              description: '방향 설정에 실패했습니다.',
            });
          }, 5000);
        }
      }));
    } catch (err) {
      pendingReverse.value = null;
      emitter.emit('hideLoading');
    }
  })();
}

const onSlatOpenClick = () => {
  emitter.emit('showLoading');
  (async () => {
    try {
      await Promise.all(curtainDevices.value.map(async (device) => {
        if (device.type == DeviceType.Rono) {
          mqttControl.onPublish(device.controllerId, device._id, {
            cmd: MQTTDooyaRonoCommand.RonoCtrl,
            type: 1,
            data: {
              addr: parseInt(device.item.address, 10),
              action: MQTTDooyaRonoAction.JogOpen,
            }
          });
        }
      }));
      setTimeout(() => emitter.emit('hideLoading'), curtainDevices.value.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
    } catch (err) {
      emitter.emit('hideLoading');
    }
  })();
};

const onSlatCloseClick = () => {
  emitter.emit('showLoading');
  (async () => {
    try {
      await Promise.all(curtainDevices.value.map(async (device) => {
        if (device.type == DeviceType.Rono) {
          mqttControl.onPublish(device.controllerId, device._id, {
            cmd: MQTTDooyaRonoCommand.RonoCtrl,
            type: 1,
            data: {
              addr: parseInt(device.item.address, 10),
              action: MQTTDooyaRonoAction.JogClose,
            }
          });
        }
      }));
      setTimeout(() => emitter.emit('hideLoading'), curtainDevices.value.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
    } catch (err) {
      emitter.emit('hideLoading');
    }
  })();
};

const onSettingMortorAddressClick = () => {
  curtainMortorAddressModal.show();
}

const onChangeNameClick = () => {
  menusButton.value.click();
  deviceItemModal.show();
}

const onDeleteClick = () => {
  menusButton.value.click();
  if (curtainDevices.value.length > 0) {
    if (curtainDevices.value[0].isVirtual && curtainDevices.value[0].item?.onoff == 1) {
      emitter.emit('showPopAlert', {
        description: 'ON 상태의 가상버튼은 삭제할 수 없습니다.',
      });
      return;
    }

    const virtualDevices = devices.value?.filter(device => device.isVirtual);
    if (!curtainDevices.value[0].isVirtual && virtualDevices.length > 0) {
      emitter.emit('showPopAlert', {
        description: '가상버튼이 있으면 삭제할 수 없습니다.',
      });
      return;
    }

    emitter.emit('showPopConfirm', {
      title: '장치 삭제',
      description: `${curtainDevices.value[0].name} 장치를 삭제하시겠습니까?`,
      okText: '삭제',
      cancelText: '취소',
      okCallback: () => {
        requestDeleteDevice(curtainDevices.value[0]._id);
      },
    });
  }
}

const onUpdateDeviceName = (value) => {
  if (value.length === 0) {
    emitter.emit('showPopAlert', {
      description: '장치 이름을 입력해주세요.',
    });
    return;
  }
  
  if (curtainDevices.value.length > 0) {
    requestUpdateDevice(curtainDevices.value[0]._id, {
      name: value,
    });
  }
  deviceItemModal.hide();
}

const onAddVirtualDeviceClick = () => {
  const hasVirtualOn = (devices.value || []).some((d) => d?.isVirtual === true && d?.item?.onoff == 1);
  if (hasVirtualOn) {
    emitter.emit('showPopAlert', {
      description: '가상 스위치가 켜져 있을 때는\n가상 스위치를 추가/수정할 수 없습니다.',
    });
    return;
  }
  router.push(`/virtual/curtain/${props.roomId}`);
}
</script>

<style scoped>
.curtain-modal-controls {
  width: 100%;
  max-width: 100%;
}

.curtain-modal-sliders {
  width: 100%;
  max-width: 100%;
}

.curtain-modal-slider-row {
  padding-top: 0.15rem;
  padding-bottom: 0.55rem;
  border: none;
}

.curtain-modal-direction-row {
  margin-top: 0.55rem;
  padding-top: 0.65rem;
  padding-bottom: 0.35rem;
}

.virtual-switch-info-root {
  border: 1px solid #e9ecef;
  border-radius: 0.9rem;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.virtual-switch-info-root.is-expanded .virtual-switch-info-header {
  border-bottom: 1px solid #e9ecef;
}

.virtual-switch-info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.35rem;
  padding: 0.4rem 0.65rem;
  background-color: #f8f9fa;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}

.virtual-switch-info-header:hover {
  background-color: #eef1f4;
}

.virtual-switch-info-title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #212529;
  text-align: left;
}

.virtual-switch-info-chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.65rem;
  height: 1.65rem;
  flex-shrink: 0;
  border-radius: 999px;
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  color: #6c757d;
  transition: color 0.2s ease, border-color 0.2s ease;
}

.virtual-switch-info-header:hover .virtual-switch-info-chevron {
  color: #0d6efd;
  border-color: #cfe2ff;
}

.virtual-switch-info-body {
  padding: 0.3rem 0.65rem 0.4rem;
  background-color: #fafbfc;
}

.virtual-switch-detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  padding: 0.28rem 0;
  font-size: 0.78rem;
}

.virtual-switch-detail-row + .virtual-switch-detail-row {
  border-top: 1px solid #eef0f2;
}

.virtual-switch-detail-label {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  color: #6c757d;
  font-weight: 500;
  flex-shrink: 0;
}

.virtual-switch-detail-label i {
  color: #0d6efd;
  width: 1rem;
  text-align: center;
}

.virtual-switch-detail-value {
  font-weight: 600;
  color: #212529;
  text-align: right;
  word-break: break-all;
}

.virtual-switch-expand-enter-active,
.virtual-switch-expand-leave-active {
  transition: opacity 0.2s ease, max-height 0.25s ease;
  overflow: hidden;
}

.virtual-switch-expand-enter-from,
.virtual-switch-expand-leave-to {
  opacity: 0;
  max-height: 0;
}

.virtual-switch-expand-enter-to,
.virtual-switch-expand-leave-from {
  opacity: 1;
  max-height: 14rem;
}

.favorite-percent-select {
  width: 5.5rem;
  flex-shrink: 0;
  font-size: 0.78rem;
  font-weight: 600;
  color: #212529;
  text-align: right;
}
</style>